import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';

/**
 * Shared header for entity detail screens (matches Contacts detail pattern).
 */
export function DetailPageHeader({ onBack, title, actions = null, subtitle = null }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 3,
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
        <Button startIcon={<BackIcon />} onClick={onBack}>
          Back
        </Button>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {subtitle}
        </Box>
      </Box>
      {actions ? (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>{actions}</Box>
      ) : null}
    </Box>
  );
}

/**
 * Two-column detail body: narrow profile / summary (md=4), main content (md=8).
 */
export function DetailTwoColumnGrid({ sidebar, children }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        {sidebar}
      </Grid>
      <Grid item xs={12} md={8}>
        {children}
      </Grid>
    </Grid>
  );
}
